import React from 'react';
import BsButtonGroup from 'react-bootstrap/es/ButtonGroup';
/**
 * This is the ButtonGroup component, a direct proxy of
 * [React Bootstrap's ButtonGroup](https://react-bootstrap.github.io/components/button-group/).
 */

var ButtonGroup = function ButtonGroup(props) {
  return React.createElement(BsButtonGroup, props);
};

ButtonGroup.displayName = 'ButtonGroup';
export default ButtonGroup;